import {GetterTree} from 'vuex'
import {PartnerUsersState, Timezone} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<PartnerUsersState, RootState> = {
  partnerUsers(state) {
    return state.partnerUsers;
  },
  partnerUserItem(state) {
    return state.partnerUserItem;
  },
  timezones() {
    let timezonesList: Timezone[] = [
      {id: 1, name: "UTC(0)"},
      {id: 2, name: "UTC+1"},
      {id: 3, name: "UTC+2"},
      {id: 4, name: "UTC+3"},
      {id: 5, name: "UTC+4"},
      {id: 6, name: "UTC+5"},
      {id: 7, name: "UTC+6"},
      {id: 8, name: "UTC+7"},
      {id: 9, name: "UTC+8"},
      {id: 10, name: "UTC+9"},
      {id: 11, name: "UTC+10"},
      {id: 12, name: "UTC+11"},
      {id: 13, name: "UTC+12"},
      {id: 14, name: "UTC-1"},
      {id: 15, name: "UTC-2"},
      {id: 16, name: "UTC-3"},
      {id: 17, name: "UTC-4"},
      {id: 18, name: "UTC-5"},
      {id: 19, name: "UTC-6"},
      {id: 20, name: "UTC-7"},
      {id: 21, name: "UTC-8"},
      {id: 22, name: "UTC-9"},
      {id: 23, name: "UTC-10"},
      {id: 24, name: "UTC-11"},
    ]
    return timezonesList;
  }
};
